module.exports = __webpack_public_path__ + "img/progress-bar-v2.c6acb791.png";